import {FilePond} from "react-filepond";
import axios from "axios";
import React, {Fragment} from "react";
import ModalMsg from "../../../../../components/ModalMsg";

export default function AddDocFirmatoView({
                                              files,
                                              setFiles,
                                              submitOk,
                                              url,
                                              token,
                                              setMessage,
                                              message,
                                              setShow,
                                              show,
                                          }) {

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={message}/>
            <h2>Aggiungi documento firmato</h2>
            <FilePond
                files={files}
                onupdatefiles={(file) => {
                    setFiles(file);
                }}
                onprocessfiles={submitOk}
                acceptedFileTypes={["application/pdf"]}
                allowFileTypeValidation={true}
                fileValidateTypeDetectType={(source, type) =>
                    new Promise((resolve, reject) => {
                        // Do custom type detection here and return with promise
                        resolve(type);
                    })
                }
                allowMultiple={true}
                allowRevert={true}
                allowReorder={true}
                allowImagePreview={true}
                imagePreviewMaxHeight={200}
                imagePreviewMarkupFilter={console.log}
                server=
                    {
                        {
                            url: url,
                            process: {
                                headers: {
                                    'jwt': token
                                },
                            },
                            revert: (uniqueFileId, load, error) => {
                                axios.delete(url + parseInt(uniqueFileId)).then((response) => {
                                    load(response)
                                });
                            }
                        }
                    }
                name="files"
                labelIdle={'Trascina qui il documento fimato o <span class="filepond--label-action">Cercalo all\'interno delle tue cartelle</span>'}
                onprocessfile={(error, file) => {
                    if(!error && file.serverId){
                        try {
                            const serverResponse = JSON.parse(file.serverId);
                            if(serverResponse.result && serverResponse.result == -1){
                                setMessage(serverResponse.description)
                                setShow(true);
                                setFiles([]);
                            }
                        } catch (parseError) {
                            setFiles([]);
                        }
                    }
                }}
            />
        </Fragment>
    );

}